<template>
  <component :is="currentTab"></component>
</template>
<script>
import HomePage from "@/views/dashboard/index";
import Tourist from "@/views/dashboard/tourist";
import { mapGetters } from "vuex";
export default {
  components: {
    HomePage,
    Tourist,
  },
  computed: {
    ...mapGetters(["token"]),
    currentTab() {
      return !this.token ? "Tourist" : "HomePage";
    },
  },
};
</script>
